import { ProjectCategory, STORAGE_KEY_PREFIX } from './types';

export function getStorageKey(workspace: 'professional' | 'private') {
  return `${STORAGE_KEY_PREFIX}${workspace}`;
}

export function loadCategories(workspace: 'professional' | 'private'): ProjectCategory[] {
  try {
    const raw = localStorage.getItem(getStorageKey(workspace));
    if (!raw) return [];
    return JSON.parse(raw) as ProjectCategory[];
  } catch {
    return [];
  }
}

export function saveCategories(workspace: 'professional' | 'private', categories: ProjectCategory[]) {
  localStorage.setItem(getStorageKey(workspace), JSON.stringify(categories));
}

export function getCategoriesFromMetadata(globalMetadata: any, workspace: 'professional' | 'private'): ProjectCategory[] {
  if (globalMetadata) {
    const list = workspace === 'professional' 
      ? globalMetadata.categories_professional 
      : globalMetadata.categories_private;
    if (Array.isArray(list) && list.length > 0) {
      return list;
    }
  }
  // Fallback to LocalStorage
  try {
    const key = `gwantt_categories_${workspace}`;
    const raw = localStorage.getItem(key);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed;
    }
  } catch {}
  return [];
}

export function areCategoriesEqual(
  a: ProjectCategory[] | null | undefined, 
  b: ProjectCategory[] | null | undefined
): boolean {
  const listA = a || [];
  const listB = b || [];
  if (listA.length !== listB.length) return false;
  
  for (let i = 0; i < listA.length; i++) {
    const itemA = listA[i];
    const itemB = listB[i];
    if (!itemA || !itemB) return false;
    if (itemA.id !== itemB.id || itemA.name !== itemB.name || itemA.color !== itemB.color) {
      return false;
    }
  }
  return true;
}
